module.exports = __webpack_public_path__ + "static/media/black dust particle.d7399681.png";